function AddTopic() {
}

module.exports = AddTopic;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/add-topic/add-topic.js
// module id = 476
// module chunks = 1